<template>
  <div class="p">
    <!-- Background layers -->
    <div class="p__bg">
      <div class="p__bg-grain"></div>
      <div class="p__bg-grad"></div>
      <div class="p__bg-grid"></div>
    </div>

    <!-- ====== HEADER ====== -->
    <header class="hdr" :class="{ 'hdr--solid': scrolled }">
      <div class="hdr__inner">
        <div class="hdr__brand">
          <img src="../assets/login-logo.png" alt="" class="hdr__logo" />
          <div class="hdr__wordmark">
            <span class="hdr__name">凯泰铭集团</span>
            <span class="hdr__en">KAITAIMING GROUP</span>
          </div>
        </div>
        <button class="hdr__login" @click="goLogin">
          <span>登录</span>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
        </button>
      </div>
    </header>

    <!-- ====== COMPANIES (first section) ====== -->
    <section class="comp" id="companies">
      <div class="comp__head v-reveal" data-reveal>
        <span class="comp__label">GROUP COMPANIES</span>
        <h2 class="comp__title">三大核心平台</h2>
        <p class="comp__desc">覆盖风控、科技、医疗三大领域的保险科技全链路生态</p>
        <div class="comp__rule"></div>
      </div>
      <div class="comp__grid">
        <div
          class="ccard v-reveal"
          data-reveal
          v-for="(item, idx) in platforms"
          :key="idx"
          :style="{ '--accent': item.color }"
        >
          <!-- scan line -->
          <div class="ccard__scan"></div>
          <!-- corner decorations -->
          <span class="ccard__corner ccard__corner--tl"></span>
          <span class="ccard__corner ccard__corner--tr"></span>
          <span class="ccard__corner ccard__corner--bl"></span>
          <span class="ccard__corner ccard__corner--br"></span>

          <div class="ccard__accent"></div>
          <div class="ccard__body">
            <div class="ccard__top">
              <div class="ccard__icon" v-html="item.svg"></div>
              <span class="ccard__num">{{ String(idx + 1).padStart(2, '0') }}</span>
            </div>
            <h3 class="ccard__name">{{ item.name }}</h3>
            <p class="ccard__text">{{ item.desc }}</p>
            <div class="ccard__tags">
              <span v-for="t in item.tags" :key="t">{{ t }}</span>
            </div>
            <button class="ccard__btn" @click="goLogin">
              <span>进入平台</span>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- ====== HERO ====== -->
    <section class="hero v-reveal" data-reveal>
      <div class="hero__ornament">
        <span></span><span></span><span></span>
      </div>
      <div class="hero__content">
        <div class="hero__tag">
          <span class="hero__tag-dot"></span>
          INSURTECH PLATFORM
        </div>
        <h1 class="hero__title">
          <span class="hero__line" style="--i:0">汇聚保险科技</span>
          <span class="hero__line" style="--i:1">产业力量</span>
        </h1>
        <div class="hero__rule"></div>
        <p class="hero__sub">以"专业 · 数据 · 人工智能"为核心的产业发展平台</p>
        <div class="hero__cta">
          <button class="btn btn--primary" @click="goLogin">
            <span>登录平台</span>
          </button>
          <a class="btn btn--wire" href="#apps">业务应用系统</a>
        </div>
      </div>
      <div class="hero__stat-bar">
        <div class="hero__stat" v-for="s in stats" :key="s.label">
          <strong>{{ s.val }}</strong>
          <span>{{ s.label }}</span>
        </div>
      </div>
    </section>

    <!-- ====== APPS GRID ====== -->
    <section class="apps" id="apps">
      <div class="apps__inner">
        <div class="apps__head v-reveal" data-reveal>
          <span class="apps__label">APPLICATIONS</span>
          <h2 class="apps__title">业务应用系统</h2>
          <p class="apps__desc">一站式访问集团下属各公司及业务平台，根据您的权限展示可访问的系统</p>
        </div>
        <div class="apps__nav v-reveal" data-reveal>
          <div class="apps__nav-item" v-for="(cat, index) in categories" :key="index"
               :class="{ active: activeCategory === cat }"
               @click="activeCategory = cat">
            {{ cat }}
          </div>
        </div>
        <div class="apps__grid">
          <div class="app-card v-reveal" data-reveal v-for="app in filteredApps" :key="app.name">
            <div class="app-card__icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18"/><path d="M9 21V9"/>
              </svg>
            </div>
            <h3 class="app-card__title">{{ app.name }}</h3>
            <p class="app-card__desc">{{ app.desc }}</p>
            <button class="app-card__btn" @click="enterApp(app)">
              <span>进入系统</span>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- ====== ABOUT ====== -->
    <section class="about">
      <div class="about__inner">
        <div class="about__deco v-reveal" data-reveal>
          <div class="about__orb"></div>
          <div class="about__ring about__ring--a"></div>
          <div class="about__ring about__ring--b"></div>
          <div class="about__ring about__ring--c"></div>
        </div>
        <div class="about__body v-reveal" data-reveal>
          <span class="about__label">ABOUT US</span>
          <h2 class="about__title">关于凯泰铭集团</h2>
          <div class="about__rule"></div>
          <p class="about__text">
            凯泰铭集团以"保险+科技"为核心，以"专业·数据·人工智能"为核心理念，
            形成覆盖车险、非车险、健康险等全险种的"保险+科技+AI"生态体系，
            致力于通过科技赋能保险行业，提升风险管理与客户服务能力，
            同时构建无界系统保险服务与保险风控体系建设，
            在新兴保险产业赛道中构建更加智能、更加系统化的风险管控能力。
          </p>
          <div class="about__grid">
            <div class="about__feat" v-for="(f, fi) in features" :key="fi">
              <span class="about__feat-bar" :style="{ '--feat-color': featuresColors[fi] }"></span>
              <span>{{ f }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ====== FOOTER ====== -->
    <footer class="ft">
      <div class="ft__inner">
        <div class="ft__brand">
          <img src="../assets/login-logo.png" alt="" class="ft__logo" />
          <span>凯泰铭集团</span>
        </div>
        <span class="ft__copy">&copy; {{ year }} 凯泰铭集团 版权所有</span>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Portal',
  data() {
    return {
      scrolled: false,
      activeCategory: '全部',
      stats: [
        { val: '10亿+', label: '年保费规模' },
        { val: '3', label: '核心业务板块' },
        { val: '100+', label: '合作企业' }
      ],
      platforms: [
        {
          name: '中安从峰',
          desc: '聚焦全空间无人系统行业，提供无人系统整体解决方案，涵盖金融、安防、医疗等应用场景，打造需求匹配与全流程一体化服务，助力行业实现智能化发展。',
          tags: ['无人系统', '金融科技', '智能安防'],
          color: '#175981',
          svg: '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>'
        },
        {
          name: '凯泰铭科技',
          desc: '致力于保险科技风控管理，运用大数据、AI、模型等核心技术，打造保险科技服务，开创科技理赔服务新生态，为行业提供智能化风控解决方案。',
          tags: ['保险风控', '大数据', 'AI引擎'],
          color: '#13A1B1',
          svg: '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/><polyline points="7 8 10 11 7 14"/><line x1="13" y1="14" x2="16" y2="14"/></svg>'
        },
        {
          name: '北尚广升',
          desc: '专注于打造"无边界医疗"的新型医疗服务企业，依托实体诊疗体系与自身能力，为患者提供高效的诊疗服务，涵盖家庭医生、管家式医疗保障服务。',
          tags: ['智慧医疗', '健康管理', '诊疗服务'],
          color: '#8EC31E',
          svg: '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78z"/></svg>'
        }
      ],
      features: ['全险种生态覆盖', 'AI智能风控体系', '无边界医疗服务', '数据驱动决策'],
      featuresColors: ['#175981', '#13A1B1', '#8EC31E', '#13A1B1'],
      categories: ['全部', '信息技术', '生产制造', '财务管理', '人力资源', '市场营销'],
      apps: [
        { name: '集团办公系统', desc: '集团总部办公系统：包含行政办公、文档管理、会议管理等功能', category: '信息技术', url: '' },
        { name: '经营数据分析', desc: '集团经营数据分析平台，业务指标监控与决策支持', category: '信息技术', url: '' },
        { name: '区域业务管理', desc: '区域业务管理平台，门店运营、库存管理、销售数据统计', category: '生产制造', url: '' },
        { name: '人力资源系统', desc: '集团人力资源管理平台，员工管理、考勤、薪酬福利', category: '人力资源', url: '' },
        { name: '财务管理系统', desc: '集团财务核算与管理平台，账务处理、报表分析、资金管理', category: '财务管理', url: '' },
        { name: '客户管理系统', desc: '客户关系管理平台，客户信息管理、销售跟踪、服务支持', category: '市场营销', url: '' },
        { name: '项目管理系统', desc: '项目全生命周期管理平台，任务分配、进度跟踪、资源协调', category: '信息技术', url: '' },
        { name: '知识库系统', desc: '集团知识共享平台，文档沉淀、经验分享、培训学习', category: '信息技术', url: '' },
        { name: '智能风控平台', desc: '基于人工智能的风险管控平台，实时监测、预警分析、决策辅助', category: '信息技术', url: '' }
      ]
    };
  },
  computed: {
    year() { return new Date().getFullYear(); },
    filteredApps() {
      if (this.activeCategory === '全部') return this.apps;
      return this.apps.filter(a => a.category === this.activeCategory);
    }
  },
  mounted() {
    this.handleScroll = () => { this.scrolled = window.scrollY > 30; };
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('v-visible');
        } else {
          e.target.classList.remove('v-visible');
        }
      });
    }, { threshold: 0.08 });
    this.$el.querySelectorAll('.v-reveal').forEach((el) => this.observer.observe(el));
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    if (this.observer) this.observer.disconnect();
  },
  methods: {
    goLogin() { this.$router.push('/portal-login'); },
    enterApp(app) {
      if (app.url) {
        window.open(app.url);
      } else {
        this.$message.info('系统建设中，敬请期待');
      }
    }
  }
};
</script>

<style lang="less" scoped>
/* =============================================
   DESIGN SYSTEM — "Deep Ocean"
   #175981         #13A1B1          #8EC31E
   ============================================= */

@abyss:     #040C16;
@deep:      #081422;
@navy:      #175981;
@teal:      #13A1B1;
@lime:      #8EC31E;
@slate:     #1C2A3E;
@steel:     #253548;
@chalk:     #E8ECF1;
@silver:    #8FA3B8;
@dim:       #4A6178;

@ease: cubic-bezier(0.23, 1, 0.32, 1);
@dur: 0.6s;
@max-w: 1200px;

/* ====== SCROLL REVEAL ====== */
.v-reveal {
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 0.6s @ease, transform 0.6s @ease;
}
.v-visible {
  opacity: 1;
  transform: translateY(0);
}

/* ====== BASE ====== */
.p {
  height: 100%;
  background: @abyss;
  color: @chalk;
  font-family: 'Outfit', 'PingFang SC', 'Noto Sans SC', 'Microsoft YaHei', system-ui, sans-serif;
  overflow-x: hidden;
  position: relative;
  -webkit-font-smoothing: antialiased;
}

/* ====== BACKGROUND ====== */
.p__bg {
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
}

.p__bg-grain {
  position: absolute;
  inset: 0;
  opacity: 0.35;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.04'/%3E%3C/svg%3E");
  background-size: 200px 200px;
}

.p__bg-grad {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(ellipse 80% 50% at 50% 0%, rgba(19, 161, 177, 0.06) 0%, transparent 60%),
    radial-gradient(ellipse 40% 50% at 80% 20%, rgba(23, 89, 129, 0.05) 0%, transparent 50%),
    radial-gradient(ellipse 50% 60% at 20% 100%, rgba(142, 195, 30, 0.03) 0%, transparent 50%);
}

.p__bg-grid {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(19, 161, 177, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(19, 161, 177, 0.03) 1px, transparent 1px);
  background-size: 60px 60px;
  mask-image: radial-gradient(ellipse 70% 50% at 50% 50%, black 20%, transparent 70%);
}

/* ====== HEADER ====== */
.hdr {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  height: 72px;
  transition: all 0.5s @ease;

  &--solid {
    background: rgba(4, 12, 22, 0.88);
    backdrop-filter: blur(20px) saturate(1.8);
    border-bottom: 1px solid rgba(19, 161, 177, 0.1);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.3);
  }
}

.hdr__inner {
  max-width: @max-w;
  margin: 0 auto;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 48px;
}

.hdr__brand {
  display: flex;
  align-items: center;
  gap: 14px;
}

.hdr__logo {
  width: 38px;
  height: 38px;
  border-radius: 8px;
  object-fit: contain;
}

.hdr__wordmark {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.hdr__name {
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 1px;
  color: @chalk;
}

.hdr__en {
  font-size: 9px;
  letter-spacing: 3px;
  color: @dim;
  font-weight: 500;
}

.hdr__login {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 24px;
  border: 1px solid @teal;
  background: transparent;
  color: @teal;
  font-size: 14px;
  font-weight: 500;
  font-family: inherit;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.35s @ease;
  letter-spacing: 0.5px;

  &:hover {
    background: rgba(19, 161, 177, 0.15);
    box-shadow: 0 0 20px rgba(19, 161, 177, 0.2);
    svg { transform: translateX(3px); }
  }
  svg { transition: transform 0.35s @ease; }
}

/* ====== COMPANIES (first) ====== */
.comp {
  position: relative;
  z-index: 1;
  max-width: @max-w;
  margin: 0 auto;
  padding: 120px 48px 80px;
}

.comp__head {
  text-align: center;
  margin-bottom: 64px;
}

.comp__label {
  display: inline-block;
  font-size: 11px;
  letter-spacing: 4px;
  color: @teal;
  font-weight: 600;
  margin-bottom: 16px;
}

.comp__title {
  font-size: clamp(28px, 4vw, 38px);
  font-weight: 700;
  color: @chalk;
  margin: 0 0 12px;
  letter-spacing: -0.5px;
}

.comp__desc {
  font-size: 15px;
  color: @silver;
  font-weight: 300;
  margin: 0 0 16px;
}

.comp__rule {
  width: 48px;
  height: 2px;
  margin: 0 auto;
  background: linear-gradient(90deg, @navy, @teal, @lime);
}

.comp__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

/* --- Company Card --- */
.ccard {
  position: relative;
  border-radius: 2px;
  overflow: hidden;
  transition: transform 0.5s @ease;

  &:hover {
    transform: translateY(-6px) scale(1.01);

    .ccard__accent { opacity: 1; height: 3px; }
    .ccard__scan { opacity: 1; animation: cardScan 2s linear infinite; }
    .ccard__corner { opacity: 1; }
    .ccard__icon {
      border-color: var(--accent);
      color: var(--accent);
      box-shadow: 0 0 16px rgba(0,0,0,0.2);
    }
    .ccard__btn {
      color: var(--accent);
      border-color: var(--accent);
      svg { transform: translateX(3px); stroke: var(--accent); }
    }
    .ccard__num { color: rgba(255,255,255,0.06); }
  }
}

.ccard__scan {
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent 5%, var(--accent) 50%, transparent 95%);
  opacity: 0;
  z-index: 2;
  pointer-events: none;
}

@keyframes cardScan {
  0%   { top: 0; }
  100% { top: 100%; }
}

.ccard__corner {
  position: absolute;
  width: 14px;
  height: 14px;
  opacity: 0;
  transition: opacity 0.5s @ease;
  z-index: 2;
  pointer-events: none;

  &::before, &::after {
    content: '';
    position: absolute;
    background: var(--accent);
  }

  &--tl { top: 6px; left: 6px;
    &::before { width: 14px; height: 1px; top: 0; left: 0; }
    &::after  { width: 1px; height: 14px; top: 0; left: 0; }
  }
  &--tr { top: 6px; right: 6px;
    &::before { width: 14px; height: 1px; top: 0; right: 0; }
    &::after  { width: 1px; height: 14px; top: 0; right: 0; }
  }
  &--bl { bottom: 6px; left: 6px;
    &::before { width: 14px; height: 1px; bottom: 0; left: 0; }
    &::after  { width: 1px; height: 14px; bottom: 0; left: 0; }
  }
  &--br { bottom: 6px; right: 6px;
    &::before { width: 14px; height: 1px; bottom: 0; right: 0; }
    &::after  { width: 1px; height: 14px; bottom: 0; right: 0; }
  }
}

.ccard__accent {
  height: 2px;
  background: linear-gradient(90deg, var(--accent), transparent 80%);
  opacity: 0.4;
  transition: opacity 0.5s @ease, height 0.5s @ease;
}

.ccard__body {
  background: @deep;
  border: 1px solid @steel;
  border-top: none;
  padding: 32px 28px 28px;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.ccard__top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.ccard__icon {
  width: 44px;
  height: 44px;
  border: 1px solid @steel;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: @teal;
  transition: all 0.4s @ease;
}

.ccard__num {
  font-size: 52px;
  font-weight: 800;
  color: rgba(255, 255, 255, 0.02);
  line-height: 1;
  letter-spacing: -3px;
  font-variant-numeric: tabular-nums;
  transition: color 0.5s;
}

.ccard__name {
  font-size: 21px;
  font-weight: 700;
  color: @chalk;
  margin: 0 0 14px;
  letter-spacing: 1px;
}

.ccard__text {
  font-size: 14px;
  color: @silver;
  line-height: 1.8;
  margin: 0 0 20px;
  flex: 1;
  font-weight: 300;
}

.ccard__tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 24px;

  span {
    padding: 3px 10px;
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.5px;
    color: var(--accent);
    background: rgba(23, 89, 129, 0.08);
    border: 1px solid rgba(23, 89, 129, 0.12);
    border-radius: 2px;
  }
}

.ccard__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 18px;
  height: 38px;
  border: 1px solid @steel;
  border-radius: 2px;
  background: transparent;
  color: @silver;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.35s @ease;
  align-self: flex-start;

  svg { transition: transform 0.35s @ease, stroke 0.35s; }
}

/* ====== HERO ====== */
.hero {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 100px 48px 80px;
  text-align: center;
}

.hero__ornament {
  display: flex;
  gap: 6px;
  margin-bottom: 36px;

  span {
    width: 24px;
    height: 1px;
    background: @teal;
    opacity: 0.4;
    &:nth-child(2) { width: 40px; opacity: 0.7; }
  }
}

.hero__content {
  max-width: 720px;
}

.hero__tag {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  letter-spacing: 4px;
  color: @teal;
  font-weight: 600;
  margin-bottom: 28px;
}

.hero__tag-dot {
  width: 6px;
  height: 6px;
  background: @lime;
  border-radius: 50%;
  animation: blink 3s ease-in-out infinite;
}

@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
}

.hero__title {
  margin: 0 0 28px;
  font-weight: 700;
  line-height: 1.12;
  letter-spacing: -1px;
}

.hero__line {
  display: block;
  font-size: clamp(40px, 6vw, 64px);

  &:first-child {
    color: #fff;
    text-shadow: 0 0 40px rgba(19, 161, 177, 0.15);
  }

  &:nth-child(2) {
    background: linear-gradient(135deg, #fff 20%, @teal 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}

.hero__rule {
  width: 64px;
  height: 2px;
  background: linear-gradient(90deg, @navy, @teal, @lime);
  margin: 0 auto 28px;
}

.hero__sub {
  font-size: 17px;
  color: @silver;
  line-height: 1.7;
  max-width: 480px;
  margin: 0 auto 40px;
  font-weight: 300;
  letter-spacing: 0.3px;
}

.hero__cta {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 48px;
  padding: 0 32px;
  font-size: 14px;
  font-weight: 600;
  font-family: inherit;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.35s @ease;
  letter-spacing: 0.5px;
  text-decoration: none;

  &--primary {
    background: linear-gradient(135deg, @navy, @teal);
    color: #fff;
    border: none;

    &:hover {
      background: linear-gradient(135deg, lighten(@navy, 8%), lighten(@teal, 8%));
      transform: translateY(-2px);
      box-shadow: 0 8px 32px rgba(19, 161, 177, 0.3);
    }
    &:active { transform: translateY(0); }
  }

  &--wire {
    background: transparent;
    color: @silver;
    border: 1px solid @steel;

    &:hover {
      color: @chalk;
      border-color: @dim;
    }
  }
}

.hero__stat-bar {
  display: flex;
  gap: 56px;
  margin-top: 80px;
  padding-top: 40px;
  border-top: 1px solid @steel;
}

.hero__stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;

  strong {
    font-size: 28px;
    font-weight: 700;
    background: linear-gradient(135deg, @teal, @lime);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    letter-spacing: -0.5px;
  }
  span {
    font-size: 12px;
    color: @dim;
    letter-spacing: 1px;
    font-weight: 500;
  }
}

/* ====== APPS SECTION ====== */
.apps {
  position: relative;
  z-index: 1;
  border-top: 1px solid @steel;
  background: linear-gradient(180deg, rgba(10, 22, 40, 0.6) 0%, transparent 100%);
}

.apps__inner {
  max-width: @max-w;
  margin: 0 auto;
  padding: 100px 48px 120px;
}

.apps__head {
  text-align: center;
  margin-bottom: 40px;
}

.apps__label {
  display: inline-block;
  font-size: 11px;
  letter-spacing: 4px;
  color: @lime;
  font-weight: 600;
  margin-bottom: 16px;
}

.apps__title {
  font-size: clamp(28px, 4vw, 38px);
  font-weight: 700;
  color: @chalk;
  margin: 0 0 12px;
  letter-spacing: -0.5px;
}

.apps__desc {
  font-size: 15px;
  color: @silver;
  font-weight: 300;
  margin: 0;
}

.apps__nav {
  display: flex;
  justify-content: center;
  gap: 8px;
  padding-bottom: 40px;
  flex-wrap: wrap;
}

.apps__nav-item {
  padding: 6px 18px;
  border-radius: 4px;
  font-size: 13px;
  color: @silver;
  background-color: rgba(28, 42, 62, 0.6);
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.3s @ease;
  font-weight: 500;

  &:hover {
    color: @chalk;
    border-color: @steel;
  }

  &.active {
    background: linear-gradient(135deg, rgba(23, 89, 129, 0.2), rgba(19, 161, 177, 0.15));
    color: @teal;
    border-color: rgba(19, 161, 177, 0.3);
  }
}

.apps__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.app-card {
  background: rgba(10, 22, 40, 0.7);
  border: 1px solid @steel;
  border-radius: 4px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  transition: all 0.4s @ease;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, @navy, @teal);
    opacity: 0;
    transition: opacity 0.4s @ease;
  }

  &:hover {
    border-color: rgba(19, 161, 177, 0.4);
    transform: translateY(-4px);
    box-shadow: 0 8px 32px rgba(19, 161, 177, 0.08);

    &::before { opacity: 1; }

    .app-card__btn {
      color: @teal;
      border-color: @teal;
      svg { transform: translateX(2px); }
    }
  }
}

.app-card__icon {
  width: 36px;
  height: 36px;
  border: 1px solid @steel;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: @teal;
  margin-bottom: 16px;
  background: rgba(19, 161, 177, 0.06);
}

.app-card__title {
  font-size: 16px;
  font-weight: 600;
  color: @chalk;
  margin: 0 0 8px;
}

.app-card__desc {
  font-size: 13px;
  color: @silver;
  line-height: 1.6;
  flex: 1;
  margin: 0 0 16px;
  font-weight: 300;
}

.app-card__btn {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0 14px;
  height: 30px;
  border: 1px solid @steel;
  border-radius: 2px;
  background: transparent;
  color: @dim;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.3s @ease;

  svg { transition: transform 0.3s @ease; }
}

/* ====== ABOUT ====== */
.about {
  position: relative;
  z-index: 1;
  border-top: 1px solid @steel;
}

.about__inner {
  max-width: @max-w;
  margin: 0 auto;
  padding: 100px 48px;
  display: grid;
  grid-template-columns: 340px 1fr;
  gap: 80px;
  align-items: center;
}

.about__deco {
  position: relative;
  height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.about__orb {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: radial-gradient(circle at 40% 35%, rgba(19, 161, 177, 0.15), rgba(23, 89, 129, 0.03) 70%);
  border: 1px solid rgba(19, 161, 177, 0.1);
  animation: orbPulse 6s ease-in-out infinite alternate;
}

@keyframes orbPulse {
  from { transform: scale(1); box-shadow: 0 0 40px rgba(19, 161, 177, 0.05); }
  to   { transform: scale(1.08); box-shadow: 0 0 60px rgba(19, 161, 177, 0.1); }
}

.about__ring {
  position: absolute;
  border-radius: 50%;
  border: 1px solid rgba(19, 161, 177, 0.04);

  &--a {
    width: 200px; height: 200px;
    border-style: dashed;
    border-color: rgba(23, 89, 129, 0.08);
    animation: spin 25s linear infinite;
  }
  &--b {
    width: 270px; height: 270px;
    border-color: rgba(19, 161, 177, 0.06);
    animation: spin 35s linear infinite reverse;
  }
  &--c {
    width: 340px; height: 340px;
    border-style: dashed;
    border-color: rgba(142, 195, 30, 0.04);
    animation: spin 50s linear infinite;
  }
}

@keyframes spin { to { transform: rotate(360deg); } }

.about__label {
  display: inline-block;
  font-size: 11px;
  letter-spacing: 4px;
  color: @teal;
  font-weight: 600;
  margin-bottom: 16px;
}

.about__title {
  font-size: clamp(26px, 3.5vw, 34px);
  font-weight: 700;
  color: @chalk;
  margin: 0 0 20px;
  letter-spacing: -0.5px;
  line-height: 1.3;
}

.about__rule {
  width: 40px;
  height: 2px;
  background: linear-gradient(90deg, @navy, @teal, @lime);
  margin-bottom: 24px;
}

.about__text {
  font-size: 15px;
  color: @silver;
  line-height: 1.9;
  margin: 0 0 36px;
  font-weight: 300;
}

.about__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px 28px;
}

.about__feat {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: @silver;
  font-weight: 400;
}

.about__feat-bar {
  width: 12px;
  height: 2px;
  background: var(--feat-color, @teal);
  flex-shrink: 0;
}

/* ====== FOOTER ====== */
.ft {
  position: relative;
  z-index: 1;
  border-top: 1px solid @steel;
}

.ft__inner {
  max-width: @max-w;
  margin: 0 auto;
  padding: 28px 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ft__brand {
  display: flex;
  align-items: center;
  gap: 10px;
  color: @dim;
  font-size: 14px;
  font-weight: 500;
}

.ft__logo {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  object-fit: contain;
}

.ft__copy {
  font-size: 12px;
  color: @dim;
  letter-spacing: 0.5px;
}

/* ====== RESPONSIVE ====== */
@media (max-width: 1024px) {
  .comp__grid {
    grid-template-columns: 1fr;
    max-width: 480px;
    margin: 0 auto;
  }
  .apps__grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .about__inner {
    grid-template-columns: 1fr;
    gap: 48px;
    padding: 80px 48px;
  }
  .about__deco { height: 240px; }
}

@media (max-width: 768px) {
  .hdr__inner { padding: 0 24px; }
  .hdr { height: 60px; }
  .comp { padding: 90px 24px 60px; }
  .hero { padding: 60px 24px; }
  .hero__sub { font-size: 15px; }
  .hero__cta {
    flex-direction: column;
    width: 100%;
    max-width: 280px;
    margin: 0 auto;
  }
  .btn { justify-content: center; width: 100%; }
  .hero__stat-bar {
    gap: 32px;
    flex-wrap: wrap;
    justify-content: center;
  }
  .apps__inner { padding: 60px 24px 80px; }
  .apps__grid { grid-template-columns: 1fr; }
  .about__inner { padding: 60px 24px; }
  .about__grid { grid-template-columns: 1fr; }
  .ft__inner {
    flex-direction: column;
    gap: 12px;
    padding: 24px;
  }
}
</style>
